"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _Error = _interopRequireDefault(require("../Form/Error"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  color: ", ";\n  overflow: hidden;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.6667;\n  padding: 8px 0;\n\n  @media print, screen and (min-width: ", "px) {\n    font-size: 1.5rem;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  outline: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0 0 15px;\n  width: 100%;\n  border: none;\n  text-align: center;\n  border: none;\n  border-collapse: ", ";\n  border-spacing: 0px;\n\n  th,\n  td {\n    text-align: left;\n    padding-left: 1.6rem;\n    padding-right: 1.6rem;\n\n    &:first-child {\n      padding-right: 0;\n      display: flex;\n      align-items: center;\n    }\n\n    &:last-child {\n      padding-left: 0;\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      padding-left: 2.4rem;\n      padding-right: 2.4rem;\n    }\n  }\n\n  td {\n    font-weight: 700;\n    padding-top: 1.6rem;\n    padding-bottom: 1.6rem;\n\n    @media print, screen and (min-width: ", "px) {\n      padding-top: 2.4rem;\n      padding-bottom: 2.4rem;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 15px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.div(_templateObject());

var Table = _styledComponents.default.table(_templateObject2(), function (props) {
  return props.borderCollapse || 'collapse';
}, _Constant.Width.MD, _Constant.Width.MD);

var TableHead = _styledComponents.default.thead(_templateObject3());

var TH = _styledComponents.default.th(_templateObject4(), _Constant.Color.DARK_GREY, _Constant.Width.MD);

var TableBody = _styledComponents.default.tbody(_templateObject5(), _Constant.Color.WHITE, _Constant.Color.DARK_GREY);

var TableGroup = function TableGroup(_ref) {
  var headers = _ref.headers,
      errorText = _ref.errorText,
      children = _ref.children,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["headers", "errorText", "children"]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(Table, otherProps, headers && /*#__PURE__*/_react.default.createElement(TableHead, null, /*#__PURE__*/_react.default.createElement("tr", null, headers.map(function (h) {
    return /*#__PURE__*/_react.default.createElement(TH, {
      key: h
    }, h);
  }))), /*#__PURE__*/_react.default.createElement(TableBody, null, children)), /*#__PURE__*/_react.default.createElement(_Error.default, {
    display: "block"
  }, errorText));
};

TableGroup.propTypes = {
  /** Used for validation */
  errorText: _propTypes.default.string,

  /** A list to be used for <th /> children */
  headers: _propTypes.default.arrayOf(_propTypes.default.node),

  /** The children of the table */
  children: _propTypes.default.node.isRequired
};
TableGroup.defaultProps = {
  headers: [],
  errorText: ''
};
var _default = TableGroup;
exports.default = _default;